import { Badge, BadgeProps } from '@chakra-ui/react'
import { useApp } from '../hooks/useApp'

export interface EnvironmentBadgeProps extends BadgeProps { }

export const EnvironmentBadge = ({ children, sx, ...rest }: EnvironmentBadgeProps) => {
  const { environment } = useApp()

  let title
  switch (environment) {
    case 'production': return null;
    case 'development': title = 'devel'; break;
    default: title = environment; break;
  }

  return (
    <Badge
      variant="solid"
      colorScheme="green"
      sx={{
        position: 'absolute',
        top: -3,
        left: -3,
        boxShadow: 'md',
        fontWeight: 'medium',
        textTransform: 'uppercase',
        transform: 'rotate(-3deg)',
        transition: 'opacity 0.2s ease-in-out',
        _hover: {
          opacity: 0.2,
        },
        ...sx,
      }}
      {...rest}
    >
      {children || title}
    </Badge>
  )
}
